import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBRow, MDBCol,MDBJumbotron   } from 'mdbreact';
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip ,PageHeader  } from 'antd';

import adminfaculty from '../adminfaculty/adminfaculty';
import Modalarticletyps from './Modalarticletypes';
import Modalcheckpayment from '../Modalcheckpayment';



import { URL,api } from '../../api';
import Modalarticleaddexpertbn from './Modalarticleaddexpertbn';
import Commentbnlistforadmin from '../expert/Commentbnlistforadmin';
import Modalsentpassbn from '../adminfaculty/Modalsentpassbn';
import Commentexlistforadmin from '../expert/Commentexlistforadmin';
import Modalupdatepass from './Modalupdatepass';





export default class superadmincheckadmintype extends Component {

    constructor(props) {
        super(props);
        this.state = {
            article:[],
            article1:[],
            article2:[],
            loading:false,
            url:'https://mua.kpru.ac.th/FrontEnd_Conferencekpru/',

        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
          this.updateat = this.updateat.bind(this);
          this.gettypepresent = this.gettypepresent.bind(this);
          this.getarticalstap2 = this.getarticalstap2.bind(this);
          this.getarticalstap22 = this.getarticalstap22.bind(this);
      }


    componentDidMount() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
    
        }

        setTimeout(() => {
          api.get('registercon/selectArticleforadmintype/'+localStorage.getItem('presentype_id'))
           .then(res => {
             console.log(res);
           
             this.setState({ article: res.data,loading: true})

           }) 
         }, 0);

    //  this.gettypepresent();
      this.getarticalstap2();
      this.getarticalstap22();

      }


      updateat(){
        setTimeout(() => {
           
          api.get('registercon/selectArticleforadmintype/'+localStorage.getItem('presentype_id'))
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article: res.data})
         }) 
       }, 0);
      }

      gettypepresent(){
        setTimeout(() => {
           
          api.get('registercon/selecttypepresentwhereid/'+localStorage.getItem('presentype_id'))
         .then(res => {
           console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
           //  this.setState({ article: res.data})
         if (res.data.length >0) {
            localStorage.setItem('presentype_name', res.data[0].presentype_name)
         }

         }) 
       }, 200);
      }

      getarticalstap2(){
        setTimeout(() => {
           
            api.get('registercon/selectArticleforadmintypestap/'+localStorage.getItem('presentype_id'))
            .then(res => {
              console.log(res);
              //  this.setState({ bankname: res.data, loading: false })
              //  this.setState({ article: res.data})
            if (res.data.length >0) {
             //   localStorage.setItem('presentype_name', res.data[0].presentype_name)
                this.setState({ article1: res.data})
            }
         }) 
       }, 0);
      }

      getarticalstap22(){
        setTimeout(() => {
           
              api.get('registercon/selectArticleforadmintypestap2/'+localStorage.getItem('presentype_id'))
              .then(res => {
                console.log(res);
                //  this.setState({ bankname: res.data, loading: false })
                //  this.setState({ article: res.data})
              if (res.data.length >0) {
               //   localStorage.setItem('presentype_name', res.data[0].presentype_name)
                  this.setState({ article2: res.data})
              }
         }) 
       }, 0);
      }





    render() {
     
        return (
            <MDBContainer fluid>
            <div>
            {/* <p className="text-right">การประชุมวิชาการระดับชาติ สำหรับนักศึกษา ครั้งที่ 4 สถาบันวิจัยและพัฒนา มหาวิทยาลัยราชภัฏกำแพงเพชร</p>  */}

            <p className="text-right">สวัสดีคุณ : {localStorage.getItem('nameuser')} ผู้ดูแลระบบประเภท {localStorage.getItem('presentype_name')}</p>
               {/* <MDBAlert color="success" >
                    <h5 className="text-right">สวัสดีคุณ : {localStorage.getItem('nameuser')} ผู้ดูแลระบบประเภท {localStorage.getItem('presentype_name')}</h5>
                </MDBAlert> */}
                <MDBRow > 
                <MDBCol md="2">
                             <MDBAlert color="info" >
                                    <PageHeader
                                    className="site-page-header"
                                // onBack={() => null}
                                    title="จำนวนบความ"
                                    //subTitle={`จำนวนบทความ ${this.state.article.length} เรื่อง` }
                                    avatar={{ src: 'https://cdn-icons-png.flaticon.com/512/8107/8107808.png' }}
                                />
                            </MDBAlert>
                            <MDBAlert color="secondary" >
                            <MDBTable striped responsive>
                                    <MDBTableHead>
                                      <tr>
                                        <th>#</th>
                                        <th>สถานะ</th>
                                        <th>จำนวน</th>
                                       
                                      </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                      <tr>
                                        <td>1</td>
                                        <td>เข้าใหม่</td>
                                        <td>Otto</td>
                                        
                                      </tr>
                                      <tr>
                                        <td>2</td>
                                        <td>ขั้นตอนบรรณาธิการ</td>
                                        <td>Thornton</td>
                                       
                                      </tr>
                                      <tr>
                                        <td>3</td>
                                        <td>ขั้นตอนผู้ทรงคุณวุฒิ</td>
                                        <td>the Bird</td>
                                        
                                      </tr>
                                      <tr>
                                        <td>4</td>
                                        <td>เสร็จสิ้น</td>
                                        <td>the Bird</td>
                                        
                                      </tr>
                                    </MDBTableBody>
                                  </MDBTable>
                            </MDBAlert>
                </MDBCol>
                <MDBCol md="10">
           {/* ขั้นตอนที่1 */}       
           <MDBJumbotron >
          
                           <MDBAlert color="info" className='mt-0' >
                                    <PageHeader
                                    className="site-page-header"
                                // onBack={() => null}
                                    title="บทความ"
                                    subTitle={`จำนวนบทความ ${this.state.article.length} เรื่อง` }
                                    avatar={{ src: 'https://cdn-icons-png.flaticon.com/512/8107/8107808.png' }}
                                />
                            </MDBAlert>
                           

                            {this.state.loading === false ?<>
                            <div className="text-center spinner-grow text-success " role="status">
                                        <span className="sr-only">Loading...</span>
                                        </div>
                            </>:<>
                            <MDBTable color="stylish-color" scrollY textWhite>
                                                <MDBTableHead  color="stylish-color" textWhite>
                                                    <tr>
                                                    <th>ลำดับ</th>
                                                    <th>ชื่อเรื่อง</th>
                                                    <th>ผู้เขียน</th>
                                                    <th>ประเภท</th>
                                                    <th>ไฟล์บทความต้นฉบับ</th>
                                                    <th>เลือกบรรณาธิการ</th>
                                                    </tr>
                                                </MDBTableHead>

                                                <MDBTableBody>
                                                {this.state.article.map((article,index )  => 
                                                    <tr>
                                                    <td>{index+1}</td>
                                                    <td>{article.name_article}</td>
                                                    <td>{article.name_present}</td>
                                                    <td>{article.presentype_name}</td>
                                                        <td>
                                                        <MDBBtn color="indigo" size="sm" href={`${this.state.url+article.send_uploadeword1}`}  target="_blank">WORD</MDBBtn>
                                                        <MDBBtn color="pink" size="sm" href={`${this.state.url+article.send_uploadepdf1}`}  target="_blank">PDF</MDBBtn>
                                                        </td>
                                                    <td>  
                                                    {/* <Modalarticletyps  id_send={article.id_send} namearticla={article.send_name}  updateat={this.updateat} /> */}
                                                    {/* <Modalcheckpayment id_send={article.id_send} namearticla={article.send_name}  updateat={this.updateat} /> */}
                                                      <Modalarticleaddexpertbn id_send={article.id_send} namearticla={article.name_article}  updateat={this.updateat} send_uploadeword1={article.send_uploadeword1} send_uploadepdf1={article.send_uploadepdf1} />
                                                    </td>
                                                    </tr>
                                                )}
                                                </MDBTableBody>
                                                </MDBTable>
                            </>}
                            </MDBJumbotron>  
{/* ขั้นตอนที่2 */}
<MDBJumbotron>
                            <MDBAlert color="info" >
                                    <PageHeader
                                    className="site-page-header"
                                // onBack={() => null}
                                    title="สถานะบรรณาธิการตรวจบทความ"
                                    subTitle={`จำนวนบทความ ${this.state.article1.length} เรื่อง` }
                                    avatar={{ src: 'https://cdn-icons-png.flaticon.com/512/5231/5231019.png' }}
                                />
                                
                            </MDBAlert>    
                            {this.state.loading === false ?<>
                            <div className="text-center spinner-grow text-success " role="status">
                                        <span className="sr-only">Loading...</span>
                                        </div>
                            </>:<>
                            <MDBTable bordered scrollY maxHeight="200vh" responsive small> 
                                                <MDBTableHead  color="stylish-color" textWhite>
                                                    <tr>
                                                    <th>ลำดับ</th>
                                                    <th>ชื่อเรื่อง</th>
                                                    <th>ผู้เขียน</th>
                                                    <th>ประเภท</th>
                                                    <th>ไฟล์บทความต้นฉบับ</th>
                                                    <th>ขั้นตอนบรรณาธิการ</th>
                                                    <th>ขั้นตอนผู้ทรงคุณวุฒิ</th>
                                                    </tr>
                                                </MDBTableHead>

                                                <MDBTableBody>
                                                {this.state.article1.map((article,index )  => 
                                                    <tr>
                                                    <td>{index+1}</td>
                                                    <td>{article.name_article}</td>
                                                    <td>{article.name_present}</td>
                                                    <td>{article.presentype_name}</td>
                                                        <td>
                                                        <MDBBtn color="indigo" size="sm" href={`${this.state.url+article.send_uploadeword1}`}  target="_blank">WORD</MDBBtn>
                                                        <MDBBtn color="pink" size="sm" href={`${this.state.url+article.send_uploadepdf1}`}  target="_blank">PDF</MDBBtn>
                                                        </td>
                                                    <td> 
                                                          <Commentbnlistforadmin id_send={article.id_send}  /> 
                                                       {/* <Modalsentpassbn id_send={article.id_send} /> */}
                                                       {/* <Modalarticletyps  id_send={article.id_send} namearticla={article.send_name}  updateat={this.updateat} /> */}
                                                       {/* <Modalcheckpayment id_send={article.id_send} namearticla={article.send_name}  updateat={this.updateat} /> */}
                                                    </td>
                                                    <td>
                                                      <Modalsentpassbn id_send={article.id_send} name_article={article.name_article} updateat={this.updateat}  />
                                                    </td>

                                                    </tr>
                                                )}
                                                </MDBTableBody>
                                                </MDBTable>
                            </>}    
                            </MDBJumbotron>   
              {/* ขั้นตอนที่3 */}
              <MDBJumbotron>
              <MDBAlert color="info" >
                                    <PageHeader
                                    className="site-page-header"
                                // onBack={() => null}
                                    title="สถานะผู้ทรงคุณวุฒิตรวจบทความ"
                                    subTitle={`จำนวนบทความ ${this.state.article2.length} เรื่อง` }
                                    avatar={{ src: 'https://cdn-icons-png.flaticon.com/512/4514/4514882.png' }}
                                />
                                
                            </MDBAlert>    
                            {this.state.loading === false ?<>
                            <div className="text-center spinner-grow text-success " role="status">
                                        <span className="sr-only">Loading...</span>
                                        </div>
                            </>:<>
                            <MDBTable bordered scrollY maxHeight="200vh" responsive small> 
                                                <MDBTableHead  color="stylish-color" textWhite>
                                                    <tr>
                                                    <th>ลำดับ</th>
                                                    <th>ชื่อเรื่อง</th>
                                                    <th>ผู้เขียน</th>
                                                    <th>ประเภท</th>
                                                    <th>ไฟล์บทความต้นฉบับ</th>
                                                    <th>ขั้นตอนผู้ทรงคุณวุฒิ</th>
                                                    {/* <th>ขั้นตอนผู้ทรงคุณวุฒิ</th> */}
                                                    </tr>
                                                </MDBTableHead>

                                                <MDBTableBody>
                                                {this.state.article2.map((article,index )  => 
                                                    <tr>
                                                    <td>{index+1}</td>
                                                    <td>{article.name_article}</td>
                                                    <td>{article.name_present}</td>
                                                    <td>{article.presentype_name}</td>
                                                        <td>
                                                        <MDBBtn color="indigo" size="sm" href={`${this.state.url+article.send_uploadeword1}`}  target="_blank">WORD</MDBBtn>
                                                        <MDBBtn color="pink" size="sm" href={`${this.state.url+article.send_uploadepdf1}`}  target="_blank">PDF</MDBBtn>
                                                        </td>
                                                    <td> 
                                                          <Commentexlistforadmin id_send={article.id_send}  /> 
                                                          <Modalupdatepass id_send={article.id_send}  />
                                                    </td>
                                                    {/* <td>
                                                      <Modalsentpassbn id_send={article.id_send} name_article={article.name_article} updateat={this.updateat}  />
                                                    </td> */}

                                                    </tr>
                                                )}
                                                </MDBTableBody>
                                                </MDBTable>
                            </>}                
                            </MDBJumbotron>

                            <MDBJumbotron>
                       <MDBAlert color="info" >
                                    <PageHeader
                                    className="site-page-header"
                                // onBack={() => null}
                                    title="บทความผ่านการพิจารณา"
                                    subTitle={`จำนวนบทความ ${this.state.article2.length} เรื่อง` }
                                    avatar={{ src: 'https://cdn-icons-png.flaticon.com/512/4514/4514882.png' }}
                                />
                                
                            </MDBAlert>    
                            {this.state.loading === false ?<>
                            <div className="text-center spinner-grow text-success " role="status">
                                        <span className="sr-only">Loading...</span>
                                        </div>
                            </>:<>
                            <MDBTable bordered scrollY maxHeight="200vh" responsive small> 
                                                <MDBTableHead  color="stylish-color" textWhite>
                                                    <tr>
                                                    <th>ลำดับ</th>
                                                    <th>ชื่อเรื่อง</th>
                                                    <th>ผู้เขียน</th>
                                                    <th>สาขา</th>
                                                    <th>ไฟล์บทความต้นฉบับ</th>
                                                    <th>ขั้นตอนผู้ทรงคุณวุฒิ</th>
                                                    {/* <th>ขั้นตอนผู้ทรงคุณวุฒิ</th> */}
                                                    </tr>
                                                </MDBTableHead>

                                                <MDBTableBody>
                                                {this.state.article2.map((article,index )  => 
                                                    <tr>
                                                    <td>{index+1}</td>
                                                    <td>{article.name_article}</td>
                                                    <td>{article.name_present}</td>
                                                    <td>{article.major_precent}</td>
                                                        <td>
                                                        <MDBBtn color="indigo" size="sm" href={`${this.state.url+article.send_uploadeword1}`}  target="_blank">WORD</MDBBtn>
                                                        <MDBBtn color="pink" size="sm" href={`${this.state.url+article.send_uploadepdf1}`}  target="_blank">PDF</MDBBtn>
                                                        </td>
                                                    <td> 
                                                          <Commentexlistforadmin id_send={article.id_send}  /> 
                                                          
                                                    </td>
                                                    {/* <td>
                                                      <Modalsentpassbn id_send={article.id_send} name_article={article.name_article} updateat={this.updateat}  />
                                                    </td> */}

                                                    </tr>
                                                )}
                                                </MDBTableBody>
                                                </MDBTable>
                            </>}                
                            </MDBJumbotron>

                </MDBCol>
                </MDBRow>

                
                      
            </div>
            </MDBContainer>
        )
    }
}
